// extracted by mini-css-extract-plugin
module.exports = {"inputs":"updatePass_inputs__2G5_s","msg":"updatePass_msg__Otn0V"};